import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export type HttpErrorDto = {
  errors: HttpErrorItemDto[];
  instance: string;
  status: HttpStatusCode;
  type: string;
  traceId: string;
  title: string;
};

type HttpErrorItemDto = {
  name: string;
  reason: string;
  code: string;
};

export const getErrorMessage = (
  errorResponse: HttpErrorResponse
): string | string[] => {
  if (errorResponse.error.reason) return [errorResponse.error.reason];
  else if (
    !!errorResponse.error.errors &&
    Array.isArray(errorResponse.error.errors)
  ) {
    return errorResponse.error.errors.map(
      (error: HttpErrorItemDto) => error.reason
    );
  } else {
    return '';
  }
};
